/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import { Tabs } from 'components/molecules/SwitchTab';
import ProductFeatureCard from 'components/molecules/ProductFeatureCard';

import useMedia from 'util/hook/useMedia';

import { useProducts } from 'models/products';

import ProductFeature from 'images/product-feature.png';
import ProductFeature1 from 'images/product-feature1.png';

import styles from './index.module.css';

interface ProductFeatureTabProperty {
	className?: string;
}

const MockSwitchTabsData = [
	{ label: '涼感棉系列', index: 0 },
	{ label: '抑菌棉系列', index: 1 },
	{ label: '褲型棉系列', index: 2 },
];

const MockProductFeatureCardsData = [
	{
		id: 1,
		imgSrc: ProductFeature,
		title: (
			<>
				好芯涼®芯片1
				<br />
				讓生理期也能很繽紛
			</>
		),
		content:
			'愛康好芯涼®芯片添加薄荷、茶樹精油獨家抑菌配方，30 秒瞬間抑菌達 99.9%讓女生在月經來潮時能有更好的選擇。',
	},
	{
		id: 2,
		imgSrc: ProductFeature1,
		title: (
			<>
				好芯涼®芯片2
				<br />
				讓生理期也能很繽紛
			</>
		),
		content:
			'愛康好芯涼®芯片添加薄荷、茶樹精油獨家抑菌配方，30 秒瞬間抑菌達 99.9%讓女生在月經來潮時能有更好的選擇。',
	},
	{
		id: 3,
		imgSrc: ProductFeature,
		title: (
			<>
				好芯涼®芯片3
				<br />
				讓生理期也能很繽紛
			</>
		),
		content:
			'愛康好芯涼®芯片添加薄荷、茶樹精油獨家抑菌配方，30 秒瞬間抑菌達 99.9%讓女生在月經來潮時能有更好的選擇。',
	},
];

const ProductFeatureTab: React.FC<ProductFeatureTabProperty> = ({ className }) => {
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const [{ indexSeries }] = useProducts();
	const media = useMedia();
	const trackRef = useRef<HTMLDivElement>(null);
	const SwitchTabsData = indexSeries.map((item, index) => ({ label: item.name!, index }));

	const ProductFeatureCardsData = indexSeries.map(item => ({
		id: item.id!,
		imgSrc: item.indexImage!,
		title: item.title!,
		content: item.description!,
	}));

	const handelTabOnClick = (index: number) => {
		if (media === 'desktop') {
			setActiveIndex(index);
			return;
		}
		if (trackRef.current) {
			const children = trackRef.current?.children;
			children.item(index)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	};

	const getProductCardOpacity = (index: number) => {
		if (media === 'mobile') {
			return 1;
		}
		return activeIndex === index ? 1 : 0.5;
	};

	useEffect(() => {
		let observer: IntersectionObserver | null = null;

		if (media === 'mobile') {
			observer = new IntersectionObserver(
				entries => {
					entries.forEach(ele => {
						if (media === 'mobile' && trackRef.current && ele.isIntersecting) {
							const index = (ele.target as HTMLElement).dataset.index || '';
							setActiveIndex(parseInt(index, 10));
						}
					});
				},
				{
					root: trackRef.current,
					threshold: 1.0,
				},
			);

			trackRef.current?.childNodes.forEach(elem => observer?.observe(elem as Element));
		}

		return () => {
			if (observer) {
				observer.disconnect();
			}
		};
	}, [media, indexSeries]);

	return (
		<div className={classnames(styles.productFeatureTab, className)}>
			<Tabs
				data={SwitchTabsData}
				activeIndex={activeIndex}
				handleClick={handelTabOnClick}
				className={styles.tabs}
				autoFoucs
			/>
			<div className={styles.container}>
				<div className={styles.trackOuter}>
					<div
						className={styles.track}
						ref={trackRef}
						style={{
							transform: `translateX(-${
								media === 'mobile' ? 0 : (activeIndex * 100) / ProductFeatureCardsData.length
							}%)`,
						}}
					>
						{ProductFeatureCardsData.map((item, index) => (
							<div
								style={{ opacity: getProductCardOpacity(index) }}
								key={item.id}
								data-index={index}
							>
								<ProductFeatureCard
									imgSrc={item.imgSrc}
									title={item.title}
									content={item.content}
									buttonName="前往選購"
									handleClick={() => {
										window.open(`/products?series=${item.id}`, '_self');
									}}
									className={styles.card}
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductFeatureTab;
